import React, { useState } from 'react';
import './style.css';
import './passwordInput.css';
import { ReactComponent as Hide } from '../../assets/images/hide.svg';
import { ReactComponent as Unhide } from '../../assets/images/unhide.svg';

function PasswordField(props) {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const {
    placeholder = 'Password',
    title = 'Password',
    name = 'password',
    id = 'password',
    error,
    onChange = () => {},
    value,
    className,
    onKeyPress,
    onMouseDown,
    onBlur,
    ref,
  } = props;

  return (
    <div className={`input-main-div ${className}`}>
      <div className="Input-headingcontainer">
        <p className="input-div">{title}</p>
      </div>
      <div className="input-wrapper-password">
        <input
          type={showPassword ? 'text' : 'password'}
          placeholder={placeholder}
          value={value}
          onBlur={onBlur}
          name={name}
          onMouseDown={onMouseDown}
          id={id}
          className={`input-new ${className}`}
          onChange={(e) => onChange(e)}
          onKeyPress={onKeyPress}
          ref={ref}
          autoComplete="off"
          data-lpignore="true"
          data-form-type="other"
        />
        <button 
          type="button"
          className="password-toggle" 
          onClick={togglePasswordVisibility}
          style={{
            background: 'none',
            border: 'none',
            padding: '0',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '18px',
            height: '18px'
          }}
        >
          {showPassword ? <Unhide style={{width: '100%', height: '100%'}} /> : <Hide style={{width: '100%', height: '100%'}} />}
        </button>
      </div>
      {error && <p className="InputErrorMsg">{error}</p>}
    </div>
  );
}

export default PasswordField;
